export default {"dateBox":"Bw2Cg","percentage":"KwO78","dateText":"BlwxT"};